// TODO: implement
export const formatCurrency = (amount, language) =>{
        if (language === "ar") {
      return new Intl.NumberFormat("ar-EG", {
        style: "currency",
        currency: "EGP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EGP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

    export const formatDate = (dateString, language) => {
    const date = new Date(dateString);
    if (language === "ar") {
      return date.toLocaleDateString("ar-EG", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  
  export const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return "Unknown";
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + " " + sizes[i];
  };
  export const calculateTotalStorage = (docs) => {
    const totalBytes = docs.reduce((sum, doc) => {
      if (!doc.size || doc.size === "Unknown") return sum;
      const sizeString = String(doc.size).trim();
      const sizeMatch = sizeString.match(/^(\d+(?:\.\d+)?)\s*(\w+)$/);
      if (!sizeMatch) return sum;
      const [, value, unit] = sizeMatch;
      const numValue = parseFloat(value);
      let bytes = 0;
      switch (unit.toUpperCase()) {
        case "BYTES":
          bytes = numValue;
          break;
        case "KB":
          bytes = numValue * 1024;
          break;
        case "MB":
          bytes = numValue * 1024 * 1024;
          break;
        case "GB":
          bytes = numValue * 1024 * 1024 * 1024;
          break;
        default:
          bytes = 0;
      }
      return sum + bytes;
    }, 0);
    return Math.round((totalBytes / (1024 * 1024)) * 100) / 100;
  };
